import React, { useEffect } from "react";
import { useHistory } from "react-router";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box";;
import Grid from "@material-ui/core/Grid";
import { useDispatch, useSelector } from "react-redux";
import { BackButton } from "~CJS/atoms/BackButton";
import OfferDetailInput from "~/components/block/OfferDetailInput";
import { initialize, OfferCreate } from "~stores/TALENTBANK/Offer";

import { offer_template_set } from "~stores/TALENTBANK/OfferTemplate";

import { ButtonNavi } from "~CJS/block/ButtonNavi";


const OfferNew = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const path = history.location.pathname.split("/");
    const offer_id = path[3];

    const TalentDetailState = useSelector((state) => state.TalentDetail);
    const OfferTemplateState = useSelector((state) => state.OfferTemplate);

    const [data, set_data] = React.useState({});




    useEffect(() => {
        dispatch(initialize());
        set_data(OfferTemplateState?.select_offer)
        dispatch(offer_template_set(['select_offer', {}]))
    }, []);

    const OfferDetailState = useSelector((state) => state.OfferDetail);

    const handleSubmit = (e) => {
        e.preventDefault();
        const offer_info = get_offer_info(e);
        const clickedButton = e.nativeEvent.submitter;



        let params = { offer_info: offer_info };

        switch (clickedButton.id) {
            case 'template':
                console.log('テンプレート保存');

                params = { offer_info: { ...offer_info, status: '4' } };
                dispatch(OfferCreate(params)).then((action) => {
                    const resdata = action.payload;
                    if (resdata.result == "1") {
                        alert("templateに作成しました。");
                        history.push(`/sponsor/OfferTemplateList`);
                    }
                });

                break;


            case 'draft':
                console.log('下書き保存');

                params = { offer_info: { ...offer_info, status: '3' } };
                dispatch(OfferCreate(params)).then((action) => {
                    const resdata = action.payload;
                    if (resdata.result == "1") {
                        alert("下書きを作成しました。");
                        history.push(`/sponsor/OfferDraftList`);
                    }
                });
                break;

            case 'insert':
                console.log('新規作成');

                if (offer_info.prefectures == '未選択') {
                    alert('都道府県は必須項目です。');
                    return;

                }
                if (!offer_info.offer_title) {
                    alert('タイトルは必須項目です。');
                    return;

                }
                if (!offer_info.job_detail) {
                    alert('お仕事詳細は必須項目です。');
                    return;

                }
                if (!offer_info.guarantee) {
                    alert('ギャランティは必須項目です。');
                    return;

                }

                dispatch(OfferCreate(params)).then((action) => {
                    const resdata = action.payload;

                    if (resdata.result == "1") {
                        alert("作成しました。");
                        history.push(`/common/OfferDetail/${resdata.offer_info.offer_id}`);
                    }
                });
                break;

            default:
                console.log('例外');
                break;
        }

    };

    const get_offer_info = (e) => {
        const elements = e.target?.elements;

        const getValue = (name) => {
            let value = "";
            if (elements[name]?.value) {
                value = elements[name]?.value;
            }

            return value;
        };

        return {
            offer_title: getValue("offer_title"),
            prefectures: getValue("prefectures"),
            city: getValue("city"),
            guarantee: getValue("guarantee"),
            recruitment_count: getValue("recruitment_count"),
            job_start_time: getValue("job_start_time"),
            job_end_time: getValue("job_end_time"),
            job_detail: getValue("job_detail"),
            job_date: getValue("job_date"),
            image_big: getValue("image_big"),
            image: getValue("image"),
            entry_close: getValue("entry_close"),
            date_text: getValue("date_text"),
            recruiting_count: getValue("recruiting_count"),
            recruiting_age: getValue("recruiting_age"),
            recruiting_sex: getValue("recruiting_sex"),
            offer_category: getValue("offer_category"),
        };


    }

    return (
        <React.Fragment>
            <Container>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">

                    {/* <BackButton history={history} /> */}
                    <ButtonNavi left_label="戻る" left_link={`/sponsor/MyOfferList`} />

                    <Box>


                        <Button color="secondary" variant="contained" onClick={() => {
                            history.push(`/sponsor/OfferTemplateList`);
                        }}>
                            テンプレ一覧
                        </Button>
                        <Button color="secondary" variant="contained" onClick={() => {
                            history.push(`/sponsor/OfferDraftList`);
                        }}>
                            下書き一覧
                        </Button>
                    </Box>
                </Grid>

                <Typography variant="h1">お仕事作成</Typography>

                <form onSubmit={handleSubmit}>
                    <OfferDetailInput data={data} />


                    <Box style={{
                        marginTop: '0.5rem',
                        border: 'solid 1px lightgray',
                        padding: '0.5rem',
                        marginBottom: '0.5rem',
                        borderRadius: '5px'
                    }}>


                        <Button color="primary" variant="contained" type="submit" name="action" id="template" component="button">
                            テンプレートに保存
                        </Button>

                        <Button color="primary" variant="contained" type="submit" name="action" id="draft" component="button">
                            下書きに保存
                        </Button>

                    </Box>

                    <Button fullWidth color="secondary" variant="contained" type="submit" name="action" id="insert" component="button">
                        作成
                    </Button>
                    ※運営が確認後公開されます
                </form>
            </Container>
        </React.Fragment>
    );
};

export default OfferNew;
